/**
 * ResolveStorageDownloadUrlUseCase
 * Resolves a tokenized, %2F-encoded Firebase Storage download URL from a
 * bucket-relative object path. Used by the encrypted-media read path so the
 * fetch hits a valid (percent-encoded, token-bearing) URL instead of
 * concatenating the raw object path onto the bucket prefix (which the Firebase
 * Storage REST endpoint rejects with HTTP 400).
 */

import { cloudStorageService } from '@/data/storage/remote/cloudStorageService';

export class ResolveStorageDownloadUrlUseCase {
  /**
   * Resolve a tokenized Firebase Storage download URL from a bucket-relative
   * object path (e.g. `chat/{group}/thumbnail/{ts}`).
   *
   * @param relativePath - Bucket-relative object path (no leading slash)
   * @returns Download URL, or null on failure (e.g. object missing).
   */
  async execute(relativePath: string): Promise<string | null> {
    return cloudStorageService.getDownloadUrl(relativePath);
  }
}

export const resolveStorageDownloadUrlUseCase = new ResolveStorageDownloadUrlUseCase();
